import { Configuration } from "@seriously-rad/seriouslyrad-framework-core/Configuration";
import { EntityCommandTypeEnum } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { $$, IJNativeEvent } from "@seriously-rad/seriouslyrad-framework-core/JNative";
import { WindowShim } from "@seriously-rad/seriouslyrad-framework-core/RadWindow";
import { registerPageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Registration";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { TabPage } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/TabPage";
import { DetailsPage } from "@seriously-rad/seriouslyrad-framework-core/Ui/Pages/DetailsPage";
import { EntityCommandEntityFileOpen } from "./EntityCommands/EntityCommandEntityFileOpen";
import { EntityCommandEntityFileUpload } from "./EntityCommands/EntityCommandEntityFileUpload";
import { EntityFileSearch } from "./Ui/Controls/EntityFileSearch";
import pageManagerConfiguration from "./Ui/PageManagerConfiguration";

const
    radWindow = WindowShim();

export async function registerModuleFilesAsync(configuration: Configuration)
{
    radWindow.entityManager?.registerCommand(new EntityCommandEntityFileOpen());
    radWindow.entityManager?.registerCommand(new EntityCommandEntityFileUpload());

    radWindow.entityManager?.removeCommand({
        type: EntityCommandTypeEnum.entitySet,
        entityName: "EntityFile",
        key: "NEW"
    });

    //$$(document).on("SeriouslyRAD.DetailsPage:childControlsCreated", (evt: IJNativeEvent, detailsPage: DetailsPage) =>
    //{
    //    if (detailsPage.tabPages)
    //    {
    //        const
    //            tabPage =
    //                new TabPage({ text: "Files", visibleEvaluator: new PermissionEvaluator({ entityName: "EntityFile", permission: PermissionEvaluator.permissionLevels.read }) })
    //                    .appendTo(detailsPage.tabPages);

    //        new EntityFileSearch()
    //            .appendTo(tabPage);
    //    }
    //});

    registerPageManagerConfiguration(configuration, pageManagerConfiguration);
}